import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import StudentRoute from "@/components/StudentRoute";
import Welcome from "@/pages/Welcome";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Timetable from "@/pages/Timetable";
import TakeAttendance from "@/pages/TakeAttendance";
import StudentSearch from "@/pages/StudentSearch";
import TeacherManagement from "@/pages/TeacherManagement";
import AdminSections from "@/pages/AdminSections";
import AdminAttendanceHub from "@/pages/AdminAttendanceHub";
import AdminFaceAttendance from "@/pages/AdminFaceAttendance";
import Profile from "@/pages/Profile";
import Analytics from "@/pages/Analytics";
import AdminStudents from "@/pages/AdminStudents";
import AdminDashboard from "@/pages/AdminDashboard";
import AdmissionPlaceholder from "@/pages/AdmissionPlaceholder";
import FinancePlaceholder from "@/pages/FinancePlaceholder";
import AdminTuitionLibrary from "@/pages/AdminTuitionLibrary";
import TeacherTuitionLibrary from "@/pages/TeacherTuitionLibrary";
import Holidays from "@/pages/Holidays";
import StudentHolidays from "@/pages/StudentHolidays";
import Events from "@/pages/Events";
import StudentEvents from "@/pages/StudentEvents";
import TuitionChat from "@/pages/TuitionChat";
import LanguageLearning from "@/pages/LanguageLearning";
import TuitionAssessment from "@/pages/TuitionAssessment";
import Students from "@/pages/Students";
import Requests from "@/pages/Requests";
import Leaves from "@/pages/Leaves";
import VoiceCalls from "@/pages/VoiceCalls";
import Homework from "@/pages/Homework";
import StudentDashboard from "@/pages/StudentDashboard";
import StudentAnnouncements from "@/pages/StudentAnnouncements";
import StudentAttendance from "@/pages/StudentAttendance";
import StudentTimetable from "@/pages/StudentTimetable";
import StudentAbsenceExplanation from "@/pages/StudentAbsenceExplanation";
import StudentProfile from "@/pages/StudentProfile";
import StudentSetPassword from "@/pages/StudentSetPassword";
import StaffSetPassword from "@/pages/StaffSetPassword";
import StudentHomework from "@/pages/StudentHomework";
import StudentOnlineClasses from "@/pages/StudentOnlineClasses";
import StudentTuitions from "@/pages/StudentTuitions";
import StudentLiveClassroom from "@/pages/StudentLiveClassroom";
import AdminLiveClassroom from "@/pages/AdminLiveClassroom";
import Assessments from "@/pages/Assessments";
import ClassResults from "@/pages/ClassResults";
import AdminResults from "@/pages/AdminResults";
import AdminSubjects from "@/pages/AdminSubjects";
import AdminSettings from "@/pages/AdminSettings";
import AdminAudit from "@/pages/AdminAudit";
import TeacherGuidance from "@/pages/TeacherGuidance";
import TeacherUtility from "@/pages/TeacherUtility";
import TeacherAnalysis from "@/pages/TeacherAnalysis";
import ClassTests from "@/pages/ClassTests";
import StudentExams from "@/pages/StudentExams";
import StudentJEE from "@/pages/StudentJEE";
import StudentResults from "@/pages/StudentResults";
import DevAdminDB from "@/pages/DevAdminDB";
import DevAdminBackups from "@/pages/DevAdminBackups";
import DevAdminVoiceConfig from "@/pages/DevAdminVoiceConfig";
import DevAdminConfig from "@/pages/DevAdminConfig";
import DevAdminAiTutor from "@/pages/DevAdminAiTutor";
import DevAdminUsers from "@/pages/DevAdminUsers";
import UtilityAdminQuestionTypes from "@/pages/UtilityAdminQuestionTypes";
import UtilityAdminSettings from "@/pages/UtilityAdminSettings";
import UtilityImports from "@/pages/UtilityImports";
import UtilityHolidays from "@/pages/UtilityHolidays";
import UtilityEvents from "@/pages/UtilityEvents";
import UtilityTools from "@/pages/UtilityTools";
import SatsView from "@/pages/SatsView";
import DevAdminStudentPasswords from "@/pages/DevAdminStudentPasswords";
import DevAdminIntegrations from "@/pages/DevAdminIntegrations";
import TutorReview from "@/pages/TutorReview";
import Announcements from "@/pages/Announcements";
import PollsManage from "@/pages/PollsManage";
import StudentPolls from "@/pages/StudentPolls";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Welcome />} />
              <Route path="/login" element={<Login />} />

              {/* Teacher / admin / super-admin routes */}
              <Route path="/select" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/attendance" element={<ProtectedRoute><TakeAttendance /></ProtectedRoute>} />
              <Route path="/timetable" element={<ProtectedRoute><Timetable /></ProtectedRoute>} />
              <Route path="/search" element={<ProtectedRoute><StudentSearch /></ProtectedRoute>} />
              <Route path="/students" element={<ProtectedRoute><Students /></ProtectedRoute>} />
              <Route path="/requests" element={<ProtectedRoute><Requests /></ProtectedRoute>} />
              <Route path="/leaves" element={<ProtectedRoute><Leaves /></ProtectedRoute>} />
              <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
              <Route path="/voice-calls" element={<ProtectedRoute><VoiceCalls /></ProtectedRoute>} />
              <Route path="/homework" element={<ProtectedRoute><Homework /></ProtectedRoute>} />
              <Route path="/assessments" element={<ProtectedRoute><Assessments /></ProtectedRoute>} />
              <Route path="/class-results" element={<ProtectedRoute><ClassResults /></ProtectedRoute>} />
              <Route path="/admin/results" element={<ProtectedRoute><AdminResults /></ProtectedRoute>} />
              <Route path="/admin/subjects" element={<ProtectedRoute><AdminSubjects /></ProtectedRoute>} />
              <Route path="/admin/audit" element={<ProtectedRoute><AdminAudit /></ProtectedRoute>} />
              <Route path="/devadmin/db" element={<ProtectedRoute><DevAdminDB /></ProtectedRoute>} />
              <Route path="/devadmin/backups" element={<ProtectedRoute><DevAdminBackups /></ProtectedRoute>} />
              <Route path="/devadmin/voice-config" element={<ProtectedRoute><DevAdminVoiceConfig /></ProtectedRoute>} />
              <Route path="/devadmin/config" element={<ProtectedRoute><DevAdminConfig /></ProtectedRoute>} />
              <Route path="/devadmin/ai-tutor" element={<ProtectedRoute><DevAdminAiTutor /></ProtectedRoute>} />
              <Route path="/devadmin/users" element={<ProtectedRoute><DevAdminUsers /></ProtectedRoute>} />
              <Route path="/devadmin/student-passwords" element={<ProtectedRoute><DevAdminStudentPasswords /></ProtectedRoute>} />
              <Route path="/devadmin/integrations" element={<ProtectedRoute><DevAdminIntegrations /></ProtectedRoute>} />
              <Route path="/staff/set-password" element={<ProtectedRoute requirePasswordSet={false}><StaffSetPassword /></ProtectedRoute>} />
              <Route path="/tutor-review" element={<ProtectedRoute><TutorReview /></ProtectedRoute>} />
              <Route path="/teacher/guidance" element={<ProtectedRoute><TeacherGuidance /></ProtectedRoute>} />
              <Route path="/more-info" element={<ProtectedRoute><TeacherAnalysis /></ProtectedRoute>} />
              <Route path="/teacher/class-tests" element={<ProtectedRoute><ClassTests /></ProtectedRoute>} />
              <Route path="/teacher/tuition-library" element={<ProtectedRoute><TeacherTuitionLibrary /></ProtectedRoute>} />
              <Route path="/teacher/utility" element={<ProtectedRoute><TeacherUtility /></ProtectedRoute>} />
              <Route path="/utility/question-types" element={<ProtectedRoute><UtilityAdminQuestionTypes /></ProtectedRoute>} />
              <Route path="/utility/settings" element={<ProtectedRoute><UtilityAdminSettings /></ProtectedRoute>} />
              <Route path="/utility/imports" element={<ProtectedRoute><UtilityImports /></ProtectedRoute>} />
              <Route path="/utility/holidays" element={<ProtectedRoute><UtilityHolidays /></ProtectedRoute>} />
              <Route path="/utility/events" element={<ProtectedRoute><UtilityEvents /></ProtectedRoute>} />
              <Route path="/utility/tools" element={<ProtectedRoute><UtilityTools /></ProtectedRoute>} />
              <Route path="/utility/sats" element={<ProtectedRoute><SatsView /></ProtectedRoute>} />
              <Route path="/holidays" element={<ProtectedRoute><Holidays /></ProtectedRoute>} />
              <Route path="/events" element={<ProtectedRoute><Events /></ProtectedRoute>} />
              <Route path="/student/jee" element={<StudentRoute><StudentJEE /></StudentRoute>} />
              <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/admin/teachers" element={<AdminRoute><TeacherManagement /></AdminRoute>} />
              <Route path="/admin/sections" element={<AdminRoute><AdminSections /></AdminRoute>} />
              <Route path="/admin/students" element={<AdminRoute><AdminStudents /></AdminRoute>} />
              <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
              <Route path="/admin/attendance" element={<AdminRoute><AdminAttendanceHub /></AdminRoute>} />
              <Route path="/admin/face-attendance" element={<AdminRoute><AdminFaceAttendance /></AdminRoute>} />
              <Route path="/admin/staff-attendance" element={<Navigate to="/admin/attendance?tab=teachers" replace />} />
              <Route path="/admin/admissions" element={<AdminRoute><AdmissionPlaceholder /></AdminRoute>} />
              <Route path="/admin/finance" element={<AdminRoute><FinancePlaceholder /></AdminRoute>} />
              <Route path="/admin/tuition-library" element={<AdminRoute><AdminTuitionLibrary /></AdminRoute>} />
              <Route path="/admin/settings" element={<AdminRoute><AdminSettings /></AdminRoute>} />
              <Route path="/announcements" element={<ProtectedRoute><Announcements /></ProtectedRoute>} />
              <Route path="/polls" element={<ProtectedRoute><PollsManage /></ProtectedRoute>} />

              {/* Student portal routes */}
              <Route path="/student/set-password" element={<StudentRoute requirePasswordSet={false}><StudentSetPassword /></StudentRoute>} />
              <Route path="/student/dashboard" element={<StudentRoute><StudentDashboard /></StudentRoute>} />
              <Route path="/student/announcements" element={<StudentRoute><StudentAnnouncements /></StudentRoute>} />
              <Route path="/student/attendance" element={<StudentRoute><StudentAttendance /></StudentRoute>} />
              <Route path="/student/timetable" element={<StudentRoute><StudentTimetable /></StudentRoute>} />
              <Route path="/student/homework" element={<StudentRoute><StudentHomework /></StudentRoute>} />
              <Route path="/student/online-classes" element={<StudentRoute><StudentOnlineClasses /></StudentRoute>} />
              <Route path="/student/tuitions" element={<StudentRoute><StudentTuitions /></StudentRoute>} />
              <Route path="/student/languages" element={<StudentRoute><LanguageLearning /></StudentRoute>} />
              <Route path="/student/polls" element={<StudentRoute><StudentPolls /></StudentRoute>} />
              <Route path="/teacher/languages" element={<ProtectedRoute><LanguageLearning /></ProtectedRoute>} />
              <Route path="/student/exams" element={<StudentRoute><StudentExams /></StudentRoute>} />
              <Route path="/student/tuitions/:subjectId/:lessonId/chat" element={<StudentRoute><TuitionChat /></StudentRoute>} />
              <Route path="/student/tuitions/assessment/:sessionId" element={<StudentRoute><TuitionAssessment /></StudentRoute>} />
              <Route path="/student/tuitions/assessment/review/:attemptId" element={<StudentRoute><TuitionAssessment /></StudentRoute>} />
              <Route path="/student/results" element={<StudentRoute><StudentResults /></StudentRoute>} />
              <Route path="/student/absence" element={<StudentRoute><StudentAbsenceExplanation /></StudentRoute>} />
              <Route path="/student/holidays" element={<StudentRoute><StudentHolidays /></StudentRoute>} />
              <Route path="/student/events" element={<StudentRoute><StudentEvents /></StudentRoute>} />
              <Route path="/student/profile" element={<StudentRoute><StudentProfile /></StudentRoute>} />
              <Route path="/student/live-classroom" element={<StudentRoute><StudentLiveClassroom /></StudentRoute>} />
              <Route path="/admin/live-classroom" element={<AdminRoute><AdminLiveClassroom /></AdminRoute>} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
